/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createToggleOfFeaturesAndRolesFromDiscriminatorValue, type ToggleOfFeaturesAndRoles } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}/Features/{key}
 */
export interface WithKeyItemRequestBuilder extends BaseRequestBuilder<WithKeyItemRequestBuilder> {
    /**
     * Gets a specific feature toggle by key.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ToggleOfFeaturesAndRoles>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ToggleOfFeaturesAndRoles | undefined>;
    /**
     * Gets a specific feature toggle by key.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithKeyItemRequestBuilderUriTemplate = "{+baseurl}/api/v{version}/Features/{key}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithKeyItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithKeyItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createToggleOfFeaturesAndRolesFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
